import { ComponentProps } from 'react';
import { CaseTab } from '@ui';
import { useCaseChatUnreadCount } from './useCaseChatUnreadCount';

type ConnectedCaseTabProps = Omit<ComponentProps<typeof CaseTab>, 'unreadCount'>;

export const ConnectedCaseTab = (props: ConnectedCaseTabProps) => {
  const { id } = props;
  const unreadCount = useCaseChatUnreadCount(id);

  return <CaseTab {...props} unreadCount={unreadCount} />;
};
